import {post} from '../utils/request'

export default {
    getAll: function (query, paginate) {
        return post("/admin/user/list", {...query, ...paginate});
    },
    findById: function (id) {
        return post("/admin/user/show", {id});
    },
    update: function (user) {
        return post("/admin/user/update", {...user, status: user.status ? 1 : 0});
    },
    updateStatus: function(id, status) {
        return post("/admin/user/updateStatus", {id, status});
    },
    updateLevel: function(id, level) {
        return post("/admin/user/updateLevel", {id, level});
    },
    changeBalance: function(balance) {
        return post("/admin/user/changeBalance", balance);
    },
    deleteById: function (id) {
        return post("/admin/user/delete", {id});
    },
}
